import {createApp} from 'vue'
import Store from 'store'
import InStockLabel from './InStockLabel'


const el = '.nlx-component--in-stock-label'
const DOM = document.querySelector(el)

if(DOM){
    
    const inStockLabelProps = {
        inStock : parseInt(DOM.dataset.inStock),
        formatted : DOM.dataset.formatted,
        formattedAvailableDate : DOM.dataset.formattedAvailableDate,
    }
    
    const component = createApp(InStockLabel, {...inStockLabelProps}).use(Store)
    component.mount(el)
}

